import React from "react";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import { randomKey } from "utils/utils";
import LoadingSpinner from "../shared/LoadingSpinner";

const UploadModal = ({
  isOpen,
  toggle,
  sheetUploadData,
  isLoading,
  onUpload,
  styles
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalBody>
        {sheetUploadData.map((county) => (
          <div key={randomKey()} style={{ marginBottom: "2rem" }}>
            <h2>Sheet Overview</h2>
            <h5>State: {county.state}</h5>
            <h5>
              County: {county.county} - {county.percentage}%
            </h5>

            <div>
              <h5>Zipcodes: {county.zipCodes.length}</h5>
              <ul style={{ listStyle: "none" }}>
                {county.zipCodes.map((zip, index) => (
                  <li key={randomKey()}>
                    {index + 1}. {zip.code}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </ModalBody>
      <ModalFooter>
        <button
          className={styles.buttonSuccess}
          disabled={isLoading}
          onClick={onUpload}
        >
          {isLoading ? <LoadingSpinner size="small" text="Uploading..." /> : "Confirm And Upload"}
        </button>
        <button className={styles.buttonOutline} onClick={toggle}>
          Cancel
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default UploadModal;